const verintState = {
  loginAttempted: false
};

export default verintState;



// WEBPACK FOOTER //
// ./src/utils/verintState.js